import { render, staticRenderFns } from "./QTDogRegistrationList.vue?vue&type=template&id=b1d93248"
import script from "./QTDogRegistrationList.vue?vue&type=script&lang=ts"
export * from "./QTDogRegistrationList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports